import { render, staticRenderFns } from "./EducationLevelFormComponent.vue?vue&type=template&id=236593cd"
import script from "./EducationLevelFormComponent.vue?vue&type=script&lang=js"
export * from "./EducationLevelFormComponent.vue?vue&type=script&lang=js"
import style0 from "./EducationLevelFormComponent.vue?vue&type=style&index=0&id=236593cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports